<template>
  <b-dropdown :size="size" variant="secondary" :text="team.name">
    <b-dropdown-item-button v-for="team in teams" :key="team.id" v-on:click.stop="chooseTeam(team)">
      <b-badge variant="primary" v-if="team.inbox_count > 0">{{team.inbox_count}}</b-badge>
      {{team.name}}
    </b-dropdown-item-button>
  </b-dropdown>
</template>


<script>
export default {
  name: 'TeamPicker',
  data () {
    return {}
  },
  props: {
    size: { type: String }
  },
  computed: {
    teams () {
      return this.$store.state.user.teams
    },
    team () {
      return this.$store.state.currentTeam
    }
  },
  methods: {
    chooseTeam (team) {
      this.$store.commit('selectCurrentTeam', team)
      this.$emit('input', team)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TeamPicker.vue